import type { OnboardingIconProps } from './OnboardingIconProps';
import { iconStroke } from './OnboardingIconProps';

/** Graduation cap */
export function LawStudentRoleIcon({ className, ...props }: OnboardingIconProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M4 13l12-6 12 6-12 6-12-6z"
        stroke="currentColor"
        {...iconStroke}
      />
      <path d="M8 15.5V22l8 4 8-4v-6.5" stroke="currentColor" {...iconStroke} />
      <path d="M26 13v7" stroke="currentColor" {...iconStroke} />
    </svg>
  );
}
